import React from 'react';
import RoleBasedLayout from './RoleBasedLayout';

const ReclutadorLayout = () => {
  return <RoleBasedLayout roleName="Reclutador" colorClass="emerald" />;
};

export default ReclutadorLayout;
